/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemUpdateWithRelativePriorityRequestSchema = z.object({
  afterId: z.int().nullish(),
  beforeId: z.int().nullish(),
  deadlineDateTime: z.iso.datetime().nullish(),
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimationId: z.int().nullish(),
  itemStatusId: z.int().nullish(),
  outOfScopeReason: z.enum(['SCOPE_FLEXIBILITY', 'PRIORITY_DRIFT']).nullish(),
  teamId: z.int().nullish(),
});
